// Environment-based configuration
const getApiBaseUrl = () => {
    // Check if we're in development mode
    if (process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost') {
        return process.env.VUE_APP_API_BASE_URL || 'http://localhost:8080';
    }
    
    // Production URL
    return process.env.VUE_APP_API_BASE_URL || 'https://ivanrozhkov-be-5h6aune3ra-ue.a.run.app';
};

export const config = {
    API_BASE_URL: getApiBaseUrl()
};